/* eslint-disable no-throw-literal */
import { APPOINTMENT_ENDPOINT, REFERRAL_DETAILS_ENDPOINT, SCHEDULE_DEVICE_ENDPOINT } from "../config/api-endpoints";
import { authorizeHeader } from "../utils/auth-header";



export const createAppointmentAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const response = await window.fetch(APPOINTMENT_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putAppointmentAPICall = async (body) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const targetURL = APPOINTMENT_ENDPOINT + `/${body.id}`
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getAppointmentAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetURL = APPOINTMENT_ENDPOINT +"/search"
    const response = await window.fetch(APPOINTMENT_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const scheduleDeviceAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetURL = SCHEDULE_DEVICE_ENDPOINT + "/search"
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const createScheduleDeviceAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const targetURL = SCHEDULE_DEVICE_ENDPOINT
    const response = await window.fetch(targetURL, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getReferralDetailsAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = REFERRAL_DETAILS_ENDPOINT + "/search"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postReferralDetailsAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = REFERRAL_DETAILS_ENDPOINT 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putReferralDetailsAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = REFERRAL_DETAILS_ENDPOINT + `/${requestBody.id}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}